// src/components/Navbar/NavbarComponent.jsx
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import PublicIcon from '@mui/icons-material/Public';
import { ButtonBase } from '@mui/material';
import styles from './NavbarComponent.module.css';

const buttonBaseSx = {
  textTransform: 'none',
  margin: '0 12px',     // ✅ matches platform StyledButton
  borderRadius: '4px',  // ✅ matches platform StyledButton
};

function NavbarComponent() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        color: '#000000',
        boxShadow: 'none',
        borderBottom: '2px solid #D3D3D3',
      }}
      className={styles.navbar}
    >
      <Toolbar>
        {/* Left: logo + divider + page name */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <ButtonBase
            component="a"
            href="https://www.utmsmartmanager.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.logoLink}
          >
            <img src="/utmlogo.svg" alt="Logo" width={60} height={60} />
          </ButtonBase>

          <div className={styles.divider} />

          <Typography variant="h6" sx={{ marginLeft: '20px', flexGrow: 1, color: '#000000' }}>
            Google UTM Builder
          </Typography>
        </Box>

        {/* Right: Public (disabled) + Personalize + Log In */}
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto', flexShrink: 0 }}>
          <Button
            size="small"
            startIcon={<PublicIcon fontSize="small" />}
            variant="outlined"
            disabled                 // ✅ matches platform anonymous “Public” badge behavior
            sx={{
              ...buttonBaseSx,
              height: 36,            // optional; platform is visually ~36px
            }}
            aria-label="Form share status: public"
          >
            Public
          </Button>

          {/* ✅ Primary CTA for top-of-funnel landing pages */}
          <Button
            size="small"
            variant="contained"
            color="primary"
            sx={{
              ...buttonBaseSx,
              height: 36,
              boxShadow: 'none',
              '&:hover': { boxShadow: 'none' },
              '&:active': { boxShadow: 'none', transform: 'scale(0.98)' },
              // Slightly tighter horizontal padding so the CTA stays tidy
              px: 1.5,
              whiteSpace: 'nowrap',
            }}
            component="a"
            href="https://app.utmsmartmanager.com/signup?intent=duplicate_template&templateKey=google_ua_utm_card&source=google_landing_nav"
            target="_blank"
            rel="noopener noreferrer"
          >
            Personalize this form
          </Button>

          {/* ✅ Keep Log In to match your publicly shared forms; make it secondary */}
          <Button
            size="small"
            variant="outlined"
            sx={{
              ...buttonBaseSx,
              height: 36,
            }}
            component="a"
            href="https://app.utmsmartmanager.com/login/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Log In
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default NavbarComponent;